import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterAccountantPage() {
  return <ClusterPageTemplate clusterName="Accountant" sectorName="Zakelijke Dienstverlening" sectorSlug="zakelijke-dienstverlening" heroTitle="Website laten maken voor een accountant" heroDescription="Professionele websites voor accountants en accountantskantoren. Wij bouwen een website die vertrouwen uitstraalt, nieuwe klanten aantrekt en jouw expertise laat zien." websiteOnderdelen={[{
    icon: 'BriefcaseIcon',
    title: 'Diensten',
    description: 'Een overzichtelijke presentatie van jouw accountancydiensten, van jaarrekeningen tot belastingadvies. Laat potentiële klanten direct zien wat je aanbiedt.'
  }, {
    icon: 'UsersIcon',
    title: 'Over ons',
    description: 'Stel je team voor en laat zien wie er achter het kantoor zit. Persoonlijk contact en vertrouwen zijn cruciaal in de accountancy.'
  }, {
    icon: 'PhoneIcon',
    title: 'Contact',
    description: 'Een duidelijke contactpagina met formulier, telefoonnummer en adresgegevens. Maak het zo makkelijk mogelijk om contact op te nemen.'
  }, {
    icon: 'SearchIcon',
    title: "SEO pagina's",
    description: 'Gerichte landingspagina\'s voor zoektermen als "accountant Alkmaar" of "boekhouder in de buurt", zodat klanten jou vinden in Google.'
  }]} functionaliteiten={[{
    icon: 'BookOpenIcon',
    title: 'Blog',
    description: 'Publiceer artikelen over belastingtips, financieel advies en actualiteiten. Dit versterkt je autoriteit en verbetert je vindbaarheid in zoekmachines.'
  }, {
    icon: 'SearchIcon',
    title: 'SEO',
    description: 'Technische en inhoudelijke zoekmachineoptimalisatie zodat jouw accountantskantoor gevonden wordt op relevante zoektermen in jouw regio.'
  }, {
    icon: 'MailIcon',
    title: 'Contactformulieren',
    description: 'Slimme formulieren die de juiste informatie ophalen, zodat je direct kunt inspelen op de vraag van een potentiële klant.'
  }]} siblingClusters={[]} faqs={[{
    q: 'Wat kost een website voor een accountant?',
    a: "De kosten voor een professionele website voor een accountantskantoor variëren afhankelijk van het aantal pagina's en de gewenste functionaliteiten. Een complete bedrijfswebsite begint vanaf €1.500. Neem contact op voor een vrijblijvende offerte op maat."
  }, {
    q: 'Hoe lang duurt het om een website voor een accountant te bouwen?',
    a: 'Gemiddeld is een website voor een accountantskantoor binnen 2 tot 4 weken live. Dit hangt af van de omvang van het project en hoe snel wij de benodigde content en materialen ontvangen.'
  }, {
    q: 'Kan ik zelf de website aanpassen?',
    a: 'Ja, wij bouwen op WordPress waardoor je eenvoudig zelf teksten, afbeeldingen en blogartikelen kunt aanpassen. Na oplevering geven wij een korte instructie.'
  }, {
    q: 'Word ik ook gevonden in Google?',
    a: "Absoluut. Lokale SEO is standaard inbegrepen. We optimaliseren voor zoektermen als 'accountant Alkmaar' of 'boekhouder in de buurt'."
  }]} data-id="element-1071" />;
}